import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useHardFacts } from "@/contexts/classified";
export const KeyFacts = () => {
    var _a;
    const hardFacts = useHardFacts();
    const keyfacts = (_a = hardFacts === null || hardFacts === void 0 ? void 0 : hardFacts.keyfacts) !== null && _a !== void 0 ? _a : [];
    if (!hardFacts)
        return null;
    return (_jsx(Box, { typography: {
            "breakpoint.base": "typography.body.14.bold",
            "breakpoint.lg": "typography.body.16.bold",
        }, display: "flex", flexWrap: "wrap", overflow: "hidden", maxHeight: "sizing.24", gap: "spacing.8", children: keyfacts.map((keyfact, index) => (_jsxs(Box, { display: "inline-flex", flexShrink: "0", whiteSpace: "nowrap", children: [index !== 0 && (_jsx("span", { "aria-hidden": true, style: { marginRight: "8px", fontSize: "small" }, children: "\u00A0\u2022\u00A0" })), _jsx(Box, { as: "span", children: keyfact })] }, keyfact))) }));
};
